import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { ErrorHandler } from "src/error/errorHandler";

const Root = lazy(() => import("src/features/root"));
const Dashboard = lazy(() => import("src/features/dashboard/dashboard"));
const SettingsLayout = lazy(() => import("src/features/settings/settingsLayout"));
const SettingsIndexPage = lazy(() => import("src/features/settings/settingsIndexPage"));
const GeneralSettingsPage = lazy(() => import("src/features/settings/general/generalSettingsPage"));
const DashboardSettingsPage = lazy(() => import("src/features/settings/dashboard/dashboardSettingsPage"));

export const routes: RouteObject = {
  element: <Root />,
  errorElement: <ErrorHandler />,
  children: [
    {
      index: true,
      element: <Dashboard />,
    },
    {
      path: "settings",
      element: <SettingsLayout />,
      children: [
        {
          index: true,
          element: <SettingsIndexPage />,
        },
        {
          path: "general",
          element: <GeneralSettingsPage />,
        },
        {
          path: "dashboard",
          element: <DashboardSettingsPage />,
        },
      ],
    },
  ],
};
